const months = [
  {
    text: '01',
    value: '01',
  },
  {
    text: '02',
    value: '02',
  },
  {
    text: '03',
    value: '03',
  },
  {
    text: '04',
    value: '04',
  },
  {
    text: '05',
    value: '05',
  },
  {
    text: '06',
    value: '06',
  },
  {
    text: '07',
    value: '07',
  },
  {
    text: '08',
    value: '08',
  },
  {
    text: '09',
    value: '09',
  },
  {
    text: '10',
    value: '10',
  },
  {
    text: '11',
    value: '11',
  },
  {
    text: '12',
    value: '12',
  },
];

export default months;
